module.exports = __webpack_public_path__ + "img/diente41.e713bd75.png";